import { render, staticRenderFns } from "./ItemContent.vue?vue&type=template&id=6218176e&scoped=true&"
import script from "./ItemContent.vue?vue&type=script&lang=js&"
export * from "./ItemContent.vue?vue&type=script&lang=js&"
import style0 from "./ItemContent.vue?vue&type=style&index=0&id=6218176e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6218176e",
  null
  
)

component.options.__file = "ItemContent.vue"
export default component.exports